import { render, staticRenderFns } from "./nutritionDayChoice.vue?vue&type=template&id=18d9170e&scoped=true"
import script from "./nutritionDayChoice.vue?vue&type=script&lang=js"
export * from "./nutritionDayChoice.vue?vue&type=script&lang=js"
import style0 from "./nutritionDayChoice.vue?vue&type=style&index=0&id=18d9170e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9170e",
  null
  
)

export default component.exports